// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2zvrV","insightsList":"newBusinessInsightsMenu_insightsList__dqzy8","active":"newBusinessInsightsMenu_active__3jDvg"};